export default __webpack_public_path__ + "static/media/Screenshot 2021-12-24 203413.24fa48bf.png";